import { List } from 'immutable';
import { investmentDocConstants } from '../constants';

export function investmentDocs(state = {}, action) {
  switch (action.type) {
    case investmentDocConstants.INVESTMENT_DOC_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case investmentDocConstants.INVESTMENT_DOC_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case investmentDocConstants.INVESTMENT_DOC_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case investmentDocConstants.INVESTMENT_DOC_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case investmentDocConstants.INVESTMENT_DOC_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case investmentDocConstants.INVESTMENT_DOC_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case investmentDocConstants.INVESTMENT_DOC_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case investmentDocConstants.INVESTMENT_DOC_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const investmentDocIndex = state.items.findIndex(val => val.id == action.response.id);

      if (investmentDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(investmentDocIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case investmentDocConstants.INVESTMENT_DOC_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case investmentDocConstants.INVESTMENT_DOC_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case investmentDocConstants.INVESTMENT_DOC_DELETE_SUCCESS: {
      const { investmentDocId } = action;

      if (!state.items) {
        return state;
      }

      const investmentDocIndex = state.items.findIndex(val => val.id == investmentDocId);

      if (investmentDocIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(investmentDocIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case investmentDocConstants.INVESTMENT_DOC_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case investmentDocConstants.INVESTMENT_DOC_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
